import { useQuery } from 'react-query';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';

const TICKET_KEY = KEYS.ticket.comment.listClosexTicket();

type Props = {
  ticketId?: number;
  ticketStatusId?: number;
  fetch?: boolean;
};

function useGetTicketComments({ ticketId, fetch }: Props) {
  const { ticket: ticketApi } = useApiContext();

  const closeTicketComents = useQuery(
    [TICKET_KEY, ticketId],
    () =>
      ticketApi.comments.listCommentsToClose({
        ticketId
      }),
    {
      select: (data) => data?.data?.data,
      refetchOnWindowFocus: false,
      enabled: fetch && !!ticketId
    }
  );
  return {
    closeTicketComents
  };
}

export default useGetTicketComments;
